import React from 'react';
import { View } from 'react-native';
import ChatMessagesSkeleton from './ChatMessagesSkeleton';

export default function ChatLoadingState() {
  return (
    <View style={{ flex: 1 }} accessibilityLabel="Loading conversation" accessibilityRole="progressbar">
      <ChatMessagesSkeleton />
    </View>
  );
}
